import type { ReactNode } from 'react';

export const symbol_battery_status_good: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m638-212 120-120q9-9 21-9t21 9.05q9 9.06 9 21.5 0 12.45-9 21.45L659-148q-9.07 9-21.53 9-12.47 0-21.47-9l-56-57q-9-9-9-21t9-21q9-9 21-9t21 9l36 35Zm-298 72Zm-30 60q-12.75 0-21.37-8.63Q280-97.25 280-110v-676q0-12.75 8.63-21.38Q297.25-816 310-816h90v-34q0-12.75 8.63-21.38Q417.25-880 430-880h100q12.75 0 21.38 8.62Q560-862.75 560-850v34h90q12.75 0 21.38 8.62Q680-798.75 680-786v298q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-268H340v616h169q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q521.75-80 509-80H310Z"
		/>
	</svg>
);
